// UI state management for search results
import { getTranslation, updateResultsBadge } from '../helpers.js';
import { renderFulltextPagination } from '../pagination.js';

/**
 * Update the search request text and badges
 */
export async function updateSearchUI(data, total) {
    const $container = $('#nav-full-text');
    
    // Update request text using backend-processed query if available
    try {
        const processedQuery = (data && typeof data.query === 'string') ? data.query : null;
        if (processedQuery) {
            const $req = $container.find('.search-request-text');
            if ($req.length) {
                // Hide Loading indicator
                const $content = $req.find('.search-request-text__content');
                if ($content.length) {
                    const $loading = $content.find('.search-request-text__loading');
                    if ($loading.length) $loading.addClass('d-none').hide();
                }
                
                // Display search time
                if (data.search_metadata && data.search_metadata.search_time) {
                    const searchTimeMs = data.search_metadata.search_time * 1000;
                    const searchTimeSec = (searchTimeMs / 1000).toFixed(2);
                    const $right = $req.find('.search-request-text__right');
                    if ($right.length) {
                        $right.html(`<span class="text-muted small">⏱ ${searchTimeSec}s</span>`);
                    }
                }
                
                const labelText = ($req.find('b').first().text() || 'Request:');
                $req.find('b').first().text(labelText);
                const $text = $req.find('.fulltext-request-text');
                if ($text.length) { $text.text(processedQuery); }
                
                // Reset change markers
                const badge = $('#nav-full-text-card-tab .fulltext-request-refresh-badge'); 
                if (badge.length) badge.addClass('d-none');
                const tx = $req.find('.fulltext-request-text'); 
                if (tx.length) tx.removeClass('fulltext-request-changed');
            }
        }
    } catch(__) {}

    // Update Content tab badge
    await updateResultsBadge(total);
}

/**
 * Handle empty results state
 */
export function handleEmptyResults(data, container) {
    const $container = $(container);
    const $spinner = $container.find('.fulltext-loading-spinner');
    if ($spinner.length) $spinner.addClass('d-none').hide();
    
    let nameSearchCount = 0;
    try {
        const $nameCount = $('#nav-names-card-tab .card-results-count');
        if ($nameCount.length) {
            const countText = $nameCount.text().trim();
            const match = countText.match(/(\d+)/);
            if (match) nameSearchCount = parseInt(match[1], 10);
        }
    } catch(_) {}
    
    const $emptyContent = $container.find('.empty-content');
    if ($emptyContent.length) {
        const $message = $emptyContent.find('.mb-1[style*="color: var(--color-text-muted)"]');
        if ($message.length && nameSearchCount > 0) {
            const searchByNameText = getTranslation('tab_search_files_short', 'Search by Name');
            const template = getTranslation('no_content_matches_with_files', 'No content matches,<br>but you have <b>{count}</b> {files}');
            const fileWord = nameSearchCount !== 1 
                ? getTranslation('file_plural', 'files')
                : getTranslation('file_singular', 'file');
            
            const messageText = template
                .replace('{count}', nameSearchCount)
                .replace('{files}', fileWord)
                .replace(/<br>/g, '<br>') + ` <a href="#" class="empty-content-switch-tab" data-tab="nav-names-card-tab">${searchByNameText}</a>`;
            
            $message.html(messageText);
            
            $message.find('.empty-content-switch-tab').off('click').on('click', function(e) {
                e.preventDefault();
                const tabId = $(this).data('tab');
                const $tabBtn = $(`#${tabId}`);
                if ($tabBtn.length) {
                    if (window.bootstrap && typeof window.bootstrap.Tab === 'function') {
                        new window.bootstrap.Tab($tabBtn[0]).show();
                    } else if (window.jQuery && typeof $tabBtn.tab === 'function') {
                        $tabBtn.tab('show');
                    }
                }
            });
        } else if ($message.length) {
            $message.text(getTranslation('no_content_matches', 'No content matches'));
        }
    }
    
    $emptyContent.removeClass('d-none');
    const $initialSpinner = $container.find('.fulltext-initial-spinner');
    if ($initialSpinner.length) $initialSpinner.addClass('d-none');
    
    try { renderFulltextPagination(data && data.pagination, window.QUERY || '', 0); } catch(__) {}
}

export function hideInitialSpinner(container) {
    const $initialSpinner = $(container).find('.fulltext-initial-spinner');
    if ($initialSpinner.length) $initialSpinner.addClass('d-none');
}
